import { render } from "./LeaderboardSection.vue?vue&type=template&id=6265aad7&scoped=true"
import script from "./LeaderboardSection.vue?vue&type=script&lang=js"
export * from "./LeaderboardSection.vue?vue&type=script&lang=js"

import "./LeaderboardSection.vue?vue&type=style&index=0&id=6265aad7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6265aad7"]])

export default __exports__